export default __webpack_public_path__ + "static/media/placeholder.efd699cb.svg";